import { ActionTypes } from '../actions';

const initialState = {
  all: [],
  current: {},
};

const ReactionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_REACTIONS:
      return { all: action.payload, current: state.current };
    case ActionTypes.FETCH_REACTION:
      return { all: state.all, current: action.payload };
    default:
      return state;
  }
};

export default ReactionsReducer;
